import { Component, Injector } from "@angular/core";
import { BlockBaseComponent } from "../block-base/block-base.component";
import { TranslocoService } from "@ngneat/transloco";
import { StoreSelectorsService } from "../../../../services";
import { actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import { MatDialog } from "@angular/material/dialog";
import { IconsComponent } from "app/components/icons/icons.component";
import { TouchLib } from "../../touch/touchLib";

@Component({
    selector: "app-scene-block-icon",
    templateUrl: "./block-icon.component.html",
    styleUrls: ["./block-icon.component.scss"],
})
export class BlockIconComponent extends BlockBaseComponent {
    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        private injector: Injector
    ) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues, null, true);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: "",
                label: this.translocoService.translate("general.color", {}, this.translocoService.getActiveLang()),
                inputType: "color",
                name: "color",
                storePath: "Data[0].Icon[0].$.color",
            },
        ];
    }

    openSwapIconDialog() {
        const dialogRef = this.dialog.open(IconsComponent, {
            width: "500px",
            minHeight: "400px",
            data: {
                currentIcon: this.sceneItem.Data[0].Icon[0].$.name
            },
        });

        this.cod(
            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.storeSelector.dispatch(
                        actionUpdateSceneItem({
                            sceneId: this.sceneId,
                            sceneItemId: this.sceneItem.$.id,
                            values: [
                                {
                                    key: "name",
                                    value: result,
                                    storePath: `Data[0].Icon[0].$`,
                                },
                            ],
                        }),
                    );
                }
            })
        )
    }

    /**
     * Touch action handler - delegates to TouchLib
     */
    public override onTouchAction() {
        if (!this.sceneId || !this.dialog || !this.injector) return;
        TouchLib.handleTouchAction(this.sceneId, this.dialog, this.injector);
    }
}
